import { render, staticRenderFns } from "./BusinessObjAttr.vue?vue&type=template&id=6886e2bf&scoped=true&"
import script from "./BusinessObjAttr.vue?vue&type=script&lang=js&"
export * from "./BusinessObjAttr.vue?vue&type=script&lang=js&"
import style0 from "./BusinessObjAttr.vue?vue&type=style&index=0&id=6886e2bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6886e2bf",
  null
  
)

export default component.exports